import {createRouter, createWebHistory, RouterView} from 'vue-router'
import HomePage from "@/pages/home-page.vue";
import translation from "@/core/helpers/translations.js";
import MarketPage from "@/pages/market-page.vue";
import RegisterPage from "@/pages/register-page.vue";
import LoginPage from "@/pages/login-page.vue";
import ResetPasswordPage from "@/pages/reset-password-page.vue";
import NewPasswordPage from "@/pages/new-password-page.vue";
import ProductPage from "@/pages/product-page.vue";
import SearchPage from "@/pages/search-page.vue";
import CartPage from "@/pages/cart-page.vue";
import WishlistPage from "@/pages/wishlist-page.vue";
import ProfilePage from "@/pages/profile-page.vue";
import {checkAuth} from "@/core/guards/notAuthGuard.js";
import ProfileBalance from "@/components/profile/profile-balance.vue";
import ProfileSettings from "@/components/profile/profile-settings.vue";
import ProfilePurchases from "@/components/profile/profile-purchases.vue";
import CheckoutPage from "@/pages/checkout-page.vue";
import TermsPage from "@/pages/terms-page.vue";
import PolicyPage from "@/pages/policy-page.vue";
import FaqPage from "@/pages/faq-page.vue";
import AboutPage from "@/pages/about-page.vue";
import DescriptionPage from "@/pages/description-page.vue";
import TagPage from "@/pages/tag-page.vue";

const routes = [
  {
    path: '/:locale?',
    component: RouterView,
    beforeEnter: translation.routeMiddleware,
    children: [
      {
        path: '',
        name: 'home',
        component: HomePage,
        meta: {
          title: "Home"
        }
      },
      {
        path: 'activate-user',
        name: 'activate-user',
        component: HomePage,
        meta: {
          title: 'Home'
        }
      },
      {
        path: 'market',
        name: 'market',
        component: MarketPage,
        meta: {
          title: "Market"
        }
      },
      {
        path: 'tags/:tag',
        name: 'tag',
        component: TagPage,
        meta: {
          title: "Market"
        }
      },
      {
        path: 'search/:searchQuery',
        name: 'search',
        component: SearchPage,
        meta: {
          title: "Search"
        }
      },
      {
        path: 'product/:productSlug',
        name: 'product',
        component: ProductPage,
        meta: {
          title: "Product"
        }
      },
      {
        path: 'cart',
        name: 'cart',
        component: CartPage,
        beforeEnter: checkAuth,
        meta: {
          title: "Cart"
        }
      },
      {
        path: 'wishlist',
        name: 'wishlist',
        component: WishlistPage,
        beforeEnter: checkAuth,
        meta: {
          title: "Wishlist"
        }
      },
      {
        path: 'sign-up',
        name: 'register',
        component: RegisterPage,
        meta: {
          title: "Sign Up"
        }
      },
      {
        path: 'sign-in',
        name: 'login',
        component: LoginPage,
        meta: {
          title: "Sign In"
        }
      },
      {
        path: 'forgot-password',
        name: 'forgot',
        component: ResetPasswordPage,
        meta: {
          title: "Forgot Password"
        }
      },
      {
        path: 'reset-password',
        name: 'reset',
        component: NewPasswordPage,
        meta: {
          title: "New Password"
        }
      },
      {
        path: 'checkout/payment',
        name: 'checkout',
        component: CheckoutPage,
        meta: {
          title: 'Checkout'
        }
      },
      {
        path: 'terms-and-conditions',
        name: 'terms',
        component: TermsPage,
        meta: {
          title: 'Terms & Conditions'
        }
      },
      {
        path: 'privacy-policy',
        name: 'policy',
        component: PolicyPage,
        meta: {
          title: 'Privacy Policy'
        }
      },
      {
        path: 'product-description',
        name: 'description',
        component: DescriptionPage,
        meta: {
          title: 'Product Description'
        }
      },
      {
        path: 'faq',
        name: 'faq',
        component: FaqPage,
        meta: {
          title: 'FAQ'
        }
      },
      {
        path: 'about-us',
        name: 'about',
        component: AboutPage,
        meta: {
          title: 'About Us'
        }
      },
      {
        path: 'profile',
        name: 'profile',
        component: ProfilePage,
        beforeEnter: checkAuth,
        meta: {
          title: "Profile"
        },
        children: [
          {
            path: 'settings',
            name: 'profile-settings',
            component: ProfileSettings,
            meta: {
              title: "Settings"
            }
          },
          {
            path: 'purchases',
            name: 'profile-purchases',
            component: ProfilePurchases,
            meta: {
              title: "Purchases"
            }
          },
          {
            path: 'top-up',
            name: 'profile-balance',
            component: ProfileBalance,
            meta: {
              title: "Top Up"
            }
          },
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth' })
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from) => {
  document.title = to.meta.title ? 'Nest Giftcards | ' + to.meta?.title : 'Nest Giftcards'
})

export default router
